import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { ErrorBoundary } from "@/components/ErrorBoundary";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Supprimer le fallback de démarrage AVANT le montage React (React va remplacer le contenu de #root)
if (window.__BOOT_STATUS__) window.__BOOT_STATUS__('Montage React...');

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
